module.exports = __webpack_public_path__ + "static/media/xiaofan.16da523a.JPG";